import { UnionMap } from '../types/union-map';

export const DefaultScheduleName = 'default';

export type ScheduleFrequency = 'Daily';

export const ScheduleFrequency: UnionMap<ScheduleFrequency> = {
    Daily: 'Daily',
};
